import './frontend/accessible-cards.js'; // Accessible cards.
import './frontend/menu.js'; // Navigation menu.
import './frontend/scroll-functions.js'; // Functions related to scrolling.
import './frontend/load-screen.js'; // Functions related to scrolling.

// Blocks
import './frontend/blocks/accordion/scripts';
import './frontend/blocks/custom-map/scripts';
import './frontend/blocks/expertise-categories/scripts';
import './frontend/blocks/load-more-posts/scripts';
import './frontend/blocks/home-layout/scripts';
import './frontend/blocks/occupations/scripts';
import './frontend/blocks/team-slider/scripts';
import './frontend/blocks/team-cards/scripts';

import { accessibleCards } from './frontend/accessible-cards.js'; // Accessible card click handlers.

// Remove no-js class on load if Javascript enabled.
document.body.classList.remove('no-js');

// Functions to run on load.
document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.add('loaded');
    accessibleCards();
});